import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "popup_wrap" }
const _hoisted_2 = { class: "btn_wrap" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "team_explain" }
const _hoisted_6 = { class: "fir-sec" }
const _hoisted_7 = { class: "second-sec" }
const _hoisted_8 = { class: "third-sec" }
const _hoisted_9 = { class: "fourth-sec" }
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.project.project_name), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _cache[0] || (_cache[0] = _createElementVNode("em", null, "개발 기간", -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.project.development_period.date) + " (약 " + _toDisplayString(_ctx.project.development_period.duration_weeks) + "주)", 1)
      ]),
      _createElementVNode("li", null, [
        _cache[1] || (_cache[1] = _createElementVNode("em", null, "팀원 구성", -1)),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.team_composition, (item, idx) => {
            return (_openBlock(), _createElementBlock("span", { key: idx }, _toDisplayString(item.name) + " : " + _toDisplayString(item.role), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("li", null, [
        _cache[2] || (_cache[2] = _createElementVNode("em", null, "개발 환경", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.development_environment, (item, idx) => {
          return (_openBlock(), _createElementBlock("span", { key: idx }, " / " + _toDisplayString(item), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.project.project_description.overview), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: _ctx.project.github_url,
        class: "git_icon",
        target: "_blank"
      }, "깃허브 바로가기", 8, _hoisted_3),
      _createElementVNode("a", {
        href: _ctx.project.site_url,
        class: "site_icon",
        target: "_blank"
      }, "서비스 바로가기", 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[10] || (_cache[10] = _createElementVNode("h3", null, "팀 프로젝트", -1)),
      _createElementVNode("section", _hoisted_6, [
        _cache[4] || (_cache[4] = _createElementVNode("h4", null, "주요 기능 및 특징", -1)),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.project_description.features, (item, idx) => {
            return (_openBlock(), _createElementBlock("li", { key: idx }, [
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "-", -1)),
              _createTextVNode(" " + _toDisplayString(item), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_7, [
        _cache[6] || (_cache[6] = _createElementVNode("h4", null, [
          _createTextVNode("팀내 기여도 "),
          _createElementVNode("span", null, "(메인 페이지 / 서브 : 구조치료ㆍ실적)")
        ], -1)),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.project_description.individual, (item, idx) => {
            return (_openBlock(), _createElementBlock("li", { key: idx }, [
              _createElementVNode("div", null, _toDisplayString(item.title), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.todo, (item2, idx2) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: idx2,
                  class: "second-p"
                }, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "-", -1)),
                  _createTextVNode(_toDisplayString(item2), 1)
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_8, [
        _cache[8] || (_cache[8] = _createElementVNode("h4", null, "트러블 슈팅", -1)),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.troubleshooting, (item, idx) => {
            return (_openBlock(), _createElementBlock("li", { key: idx }, [
              _createElementVNode("div", null, "[" + _toDisplayString(item.title) + "]", 1),
              _createElementVNode("p", null, _toDisplayString(item.problem), 1),
              _createElementVNode("span", null, [
                _cache[7] || (_cache[7] = _createElementVNode("i", null, "ㄴ", -1)),
                _createTextVNode(_toDisplayString(item.solution), 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_9, [
        _cache[9] || (_cache[9] = _createElementVNode("h4", null, "로고 작업", -1)),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.logo.photo, (item, k) => {
            return (_openBlock(), _createElementBlock("img", {
              key: k,
              src: require(`../assets/${item}`),
              alt: "프로젝트 로고"
            }, null, 8, _hoisted_10))
          }), 128))
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("section", { class: "fifth-sec" }, [
        _createElementVNode("h4", null, "작업 화면"),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("img", {
              scr: "",
              alt: ""
            })
          ])
        ])
      ], -1))
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("button", { class: "morebtn" }, "더보기", -1))
  ]))
}